import {
  TbArrowsLeftRight,
  TbBuilding,
  TbCategoryPlus,
  TbColumns2,
  TbFileText,
  TbHelpCircle,
  TbMapPin2,
  TbMenu2,
  TbReplace,
  TbSearch,
  TbSquarePlus,
  TbTableExport,
  TbUsersGroup,
} from 'react-icons/tb';

export const IconHelp = TbHelpCircle;

export const IconTableExport = TbTableExport;

export const IconColumns = TbColumns2;

export const IconWorkOrderCreate = TbSquarePlus;

export const IconMenu = TbMenu2;

export const IconSearch = TbSearch;

export const IconWorkOrder = TbFileText;

export const IconStops = TbMapPin2;

export const IconReplace = TbReplace;

export const IconBuilding = TbBuilding;

export const IconUsers = TbUsersGroup;

export const IconGroupAdd = TbCategoryPlus;

export const IconStateChange = TbArrowsLeftRight;
